import { getElements } from '../Utility/Dom'

class CourseFilter {
  private readonly selects: NodeListOf<HTMLElement>

  constructor() {
    this.selects = getElements('course-filter-select')
  }

  public init(): void {
    this.selects.forEach((element: HTMLElement): void => {
      if (!(element instanceof HTMLSelectElement)) return

      element.addEventListener('change', (): void => {
        element.form?.submit()
      })
    })
  }
}

const courseFilter = new CourseFilter()
courseFilter.init()
